import { OENPanel } from "../enums/oe-panel.enum";
import { OENInputControl } from "../enums/oe-input-control.enum";

/**
 * BfxOrderEntryInputModel
 * ----------------------------------
 * This model is used for loading of data in the display interface components, as well as locking state of interface components.
 * In addition, external validation errors are propagated
 */
export class OEInputModel {
  // must
  public panel: OENPanel;
  public input: OENInputControl;
  public value: any;

  constructor(
    _panel: OENPanel,
    _input: OENInputControl,
    _value?: any,
    public hasPrivatization: boolean = false,
  ) {
    this.panel = _panel;
    this.input = _input;
    this.value = _value != null ? _value : null;
  }
}
